export const MAIN_THEME_COLOR = '#28696D';
export const WHITE = '#FFFFFF';
export const BLACK = '#000000';
export const GREY = '#A6A5A5';
